//NPM Packages
import { React, useContext } from "react";
import styled from "styled-components";

//Context
import MyContext from "../context/MyContext";

//Components
import Address from "../components/DemoLeads/Address";
import Authentication from "../components/Shared/Authentication";
import Customer from "../components/DemoLeads/Customer";
import Docs from "../components/DemoLeads/Docs";
import Declartion from "../components/DemoLeads/Declartion";

import Header from "../components/Shared/Header";
import { Wrapper } from "../components/styles/Wrapper.styled";

const FormWrapper = styled.div`
  padding: ${(props) => props.theme.space[1]};

  @media ${({ theme }) => theme.device.mobileL} {
    padding: ${(props) => props.theme.space[2]};
  }

  @media ${({ theme }) => theme.device.laptop} {
    padding: ${(props) => props.theme.space[3]};
  }
`;

export default function DemoLeads(props) {
  const {
    //Authentication
    idVerification,
    idVerificationRequired,

    //Forms
    addressDataCaptured,
    customerDataCaptured,
    docsDataCaptured,
  } = useContext(MyContext);

  return (
    <Wrapper>
      <Header
        name="Laminin Demo Application"
        description="Laminin Demo Application"
        logoPath="../images/laminin-demo-white-bg.png"
      />
      {!idVerification && idVerificationRequired && (
        <Authentication phone="0100 546 546" />
      )}

      {(idVerification || !idVerificationRequired) && (
        <FormWrapper>
          {!customerDataCaptured && (
            <Customer name="Laminin" formName="Demo Form" />
          )}

          {!addressDataCaptured && customerDataCaptured && (
            <Address name="Laminin" formName="Demo Form" />
          )}

          {addressDataCaptured && customerDataCaptured && (
            <Declartion
              name="Laminin"
              formName="Demo Form"
              logoPath="../images/laminin-demo-white-bg.png"
              phone="0100 546 546"
            />
          )}
        </FormWrapper>
      )}
    </Wrapper>
  );
}
